import React from "react";

import Button, { ButtonTypes } from "../../../../../../components/Button";
import { formatCurrency } from "../../../../../../utils";
import { EstimatedVariantProps } from "./types";
import { LogPaymentButton } from "./LogPaymentButton";
import {
  ApproxRow,
  ApproxGlyph,
  NextAmount,
  EstBadge,
  EstimateNote,
} from "./styles";

export const EstimatedVariant: React.FC<EstimatedVariantProps> = ({
  paymentAmount,
  estimateNote,
  onLogPayment,
  onEditLiability,
}) => (
  <>
    <ApproxRow>
      <ApproxGlyph aria-hidden="true">≈</ApproxGlyph>
      <NextAmount data-testid="liability-next-amount">
        {formatCurrency(paymentAmount)}
      </NextAmount>
      <EstBadge>Est.</EstBadge>
    </ApproxRow>
    <EstimateNote>{estimateNote}</EstimateNote>
    <LogPaymentButton onLogPayment={onLogPayment} />
    <Button
      type={ButtonTypes.link}
      buttonType="button"
      onClick={onEditLiability}
      data-testid="liability-add-fixed"
    >
      Add a fixed amount to track the exact installment
    </Button>
  </>
);
